module.exports = __webpack_public_path__ + "img/bluetooth.17e072f7.svg";